import { render, staticRenderFns } from "./CreditCardPaymentComponentNovalnet.vue?vue&type=template&id=3ff4d64c"
import script from "./CreditCardPaymentComponentNovalnet.vue?vue&type=script&lang=js"
export * from "./CreditCardPaymentComponentNovalnet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports